<template>
  <div>
    <a-layout>
      <a-row style="background-color: #FFFFFF;">
        <a-col :span="10">
          <a-col :span="24" style="padding: 0 8px;">
            <h3 style="float: left;">类型列表</h3>
            <a-button type="primary" style="float: right;margin-right: 8px;" @click="addType">添加类型</a-button>
          </a-col>
          <a-col :span="24">
            <a-table id="typeTable" :columns="typesHeader" :data-source="data" :scroll="{y: table.scrollHeight}" :key="'id'" :rowKey="'id'" :customRow="customRow" :rowClassName="rowClassName">
              <span slot="remarks" slot-scope="remarks">
                 {{remarks && remarks.length > 0?remarks:"-"}}
              </span>
              <span slot="enable" slot-scope="item">
                 <a-switch checked-children="已启用" un-checked-children="不启用" v-model="item.enable" @change="switchTypeEnable(item)"/>
              </span>
              <span slot="ops" slot-scope="item">
                <a class="op-btn" @click="updateType(item)">修改</a>
                <a class="op-btn" style="color: #666666;" @click="deleteType(item)">删除</a>
              </span>
            </a-table>
          </a-col>
        </a-col>
        <a-col :span="14">
          <a-col :span="24" style="padding:0 8px;">
            <h3 style="float: left;">值列表</h3>
            <a-button type="primary" style="float: right;" @click="addValue">添加值</a-button>
          </a-col>
          <a-col :span="24">
            <a-table style="margin-left: 8px;" :columns="valuesHeader" :data-source="values" :scroll="{y: table.scrollHeight}" key="id" rowKey="id" :pagination="false">
              <span slot="enable" slot-scope="item">
                <a-switch checked-children="已启用" un-checked-children="不启用" v-model="item.enable" @change="switchValueEnable(item)"/>
              </span>
              <span slot="remarks" slot-scope="remarks">
                {{remarks && remarks.length > 0?remarks:"-"}}
              </span>
              <span slot="ops" slot-scope="item">
                <a class="op-btn" @click="updateValue(item)">修改</a>
                <a class="op-btn" style="color: #666666;" @click="deleteValue(item)">删除</a>
              </span>
            </a-table>
          </a-col>
        </a-col>
      </a-row>
    </a-layout>
    <!--添加类型模态框-->
    <a-modal title="添加字典类型" :dialog-style="modalAddType.style" :visible="modalAddType.show" :confirm-loading="modalAddType.confirmLoading" @ok="confirmAddType" @cancel="cancelAddType">
      <a-form :form="modalAddType.form" :label-col="{span: 5}" :wrapper-col="{span: 16}">
        <a-form-item label="key" :wrapper-col="{span: 10}">
          <a-input v-decorator="['key',{rules:[{required: true,message: 'key必须输入'}]}]"/>
        </a-form-item>
        <a-form-item label="类型" :wrapper-col="{span: 10}">
          <a-input v-decorator="['typeName',{rules:[{required: true,message: '类型必须输入'}]}]"/>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number v-model="modalAddType.model.sort" :min="0"/>
        </a-form-item>
        <a-form-item label="启用">
          <a-switch v-model="modalAddType.model.enable"/>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="modalAddType.model.remarks" placeholder="备注信息" :rows="2"/>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--修改字典类型-->
    <a-modal title="修改字典类型" :dialog-style="modalUpdateType.style" :visible="modalUpdateType.show" :confirm-loading="modalUpdateType.confirmLoading" @ok="confirmUpdateType" @cancel="cancelUpdateType">
      <a-form :form="modalUpdateType.form" :label-col="{span: 5}" :wrapper-col="{span: 16}">
        <a-form-item label="类型" :wrapper-col="{span: 10}">
          <a-input v-decorator="['key',{rules:[{required: true,message: 'key必须输入'}]}]"/>
        </a-form-item>
        <a-form-item label="类型" :wrapper-col="{span: 10}">
          <a-input v-decorator="['typeName',{rules:[{required: true,message: '类型必须输入'}]}]"/>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number v-model="modalUpdateType.model.sort" :min="0"/>
        </a-form-item>
        <a-form-item label="启用">
          <a-switch v-model="modalUpdateType.model.enable"/>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="modalUpdateType.model.remarks" placeholder="备注信息" :rows="2"/>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--添加值模态框-->
    <a-modal title="添加字典值" :dialog-style="modalAddValue.style" :visible="modalAddValue.show" :confirm-loading="modalAddValue.confirmLoading" @ok="confirmAddValue" @cancel="cancelAddValue">
      <a-form :form="modalAddValue.form" :label-col="{span: 5}" :wrapper-col="{span: 16}">
        <a-form-item label="字典类型" :wrapper-col="{span: 10}">
          <a-input :disabled="true" v-if="selectedRow != null" v-model="selectedRow.typeName"/>
        </a-form-item>
        <a-form-item label="值" :wrapper-col="{span: 10}">
          <a-input v-decorator="['value',{rules:[{required: true,message: '值必须输入'}]}]"/>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number v-model="modalAddValue.model.sort" :min="0"/>
        </a-form-item>
        <a-form-item label="启用">
          <a-switch v-model="modalAddValue.model.enable"/>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="modalAddValue.model.remarks" placeholder="备注信息" :rows="2"/>
        </a-form-item>
      </a-form>
    </a-modal>
    <!--修改字典值-->
    <a-modal title="修改字典值" :dialog-style="modalUpdateValue.style" :visible="modalUpdateValue.show" :confirm-loading="modalUpdateValue.confirmLoading" @ok="confirmUpdateValue" @cancel="cancelUpdateValue">
      <a-form :form="modalUpdateValue.form" :label-col="{span: 5}" :wrapper-col="{span: 16}">
        <a-form-item label="字典类型" :wrapper-col="{span: 10}">
          <a-input :disabled="true" v-if="selectedRow != null" v-model="selectedRow.typeName"/>
        </a-form-item>
        <a-form-item label="值" :wrapper-col="{span: 10}">
          <a-input v-decorator="['value',{rules:[{required: true,message: '值必须输入'}]}]"/>
        </a-form-item>
        <a-form-item label="排序">
          <a-input-number v-model="modalUpdateValue.model.sort" :min="0"/>
        </a-form-item>
        <a-form-item label="启用">
          <a-switch v-model="modalUpdateValue.model.enable"/>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-model="modalUpdateValue.model.remarks" placeholder="备注信息" :rows="2"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

import DictionaryService from "@/service/DictionaryService";

export default {
  name: "Dictionary",
  data(){
    return {
      //添加模态框
      modalAddType: {
        style: {
          top: '50vh',
          marginTop: '-300px'
        },
        show: false,
        confirmLoading: false,
        form: this.$form.createForm(this,{name: 'formAddType'}),
        model: {
          enable: true,
          sort: 0,
          remarks: null
        }
      },
      //修改字典类型模态框
      modalUpdateType: {
        style: {
          top: '50vh',
          marginTop: '-300px'
        },
        show: false,
        confirmLoading: false,
        form: this.$form.createForm(this,{name: 'formUpdateType'}),
        model: {
          enable: true,
          sort: 0,
          remarks: null
        },
        item: null
      },
      //添加值模态框
      modalAddValue: {
        style: {
          top: '50vh',
          marginTop: '-300px'
        },
        show: false,
        confirmLoading: false,
        form: this.$form.createForm(this,{name: 'formAddValue'}),
        model: {
          enable: true,
          sort: 0,
          remarks: null
        }
      },
      //修改值模态框
      modalUpdateValue: {
        style: {
          top: '50vh',
          marginTop: '-300px'
        },
        show: false,
        confirmLoading: false,
        form: this.$form.createForm(this,{name: 'formUpdateValue'}),
        model: {
          enable: true,
          sort: 0,
          remarks: null
        },
        item: null
      },
      selectedRow: null,
      typesHeader: [
        {
          title: '类型名',
          dataIndex: 'typeName',
          key: 'typeName',
        },
        {
          title: '排序值',
          dataIndex: 'sort',
          key: 'age',
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          key: 'remarks',
          scopedSlots: {customRender: 'remarks'}
        },
        {
          title: '启用',
          scopedSlots: {customRender: 'enable'}
        },
        {
          title: '操作',
          scopedSlots: {customRender: 'ops'}
        }
      ],
      valuesHeader: [
        {
          title: '值',
          dataIndex: 'value',
          key: 'value'
        },
        {
          title: '排序值',
          dataIndex: 'sort',
          key: 'sort',
        },
        {
          title: '启用',
          scopedSlots: {customRender: 'enable'}
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          key: 'remarks',
          scopedSlots: {customRender: 'remarks'}
        },
        {
          title: '操作',
          scopedSlots: {customRender: 'ops'}
        }
      ],
      table: {
        scrollHeight: 0
      },
      data: null,
      values: null
    }
  },
  methods:{
    //自定义row
    customRow(record){
      return {
        on: {
          click: (event)=> {
            this.selectedRow = record;
            //获取值列表
            DictionaryService.getValueList(record.key).then(data=> {
              this.values = data;
            }).catch(e=>{
              this.$message.error(e);
            })
          }
        }
      }
    },
    rowClassName(rec,index){
      if (this.selectedRow && this.selectedRow.key === rec.key){
        return 'selected-row';
      }
      return null;
    },
    //添加类型
    addType(){
      this.modalAddType.show = true;
    },
    //确认添加类型
    confirmAddType(e){
      e.preventDefault();
      this.modalAddType.form.validateFields((err,values)=>{
        if (!err){
          values.sort = this.modalAddType.model.sort;
          values.enable = this.modalAddType.model.enable;
          values.remarks = this.modalAddType.model.remarks;
          let _this = this;

          console.log("values:",values);
          this.$confirm({
            title: "确定创建该字典类型吗？",
            content: "单击确定创建",
            onOk: function (){
              DictionaryService.createType(values).then(data=>{
                _this.modalAddType.show = false;
                _this.modalAddType.form.resetFields();
                _this.refreshTypeData();
              }).catch(e=>{
                console.log("e",e);
                _this.$message.error(e);
              })
            }
          });
        }
      });
    },
    //取消添加类型
    cancelAddType(){
      this.modalAddType.show = false;
    },
    //刷新的类型数据
    refreshTypeData(){
      DictionaryService.getTypeList().then(data=>{
        this.data = data.list;
      }).catch(e=>{
        console.log("e",e);
        this.$message.error("获取数据失败");
      });
    },
    //刷新值数据
    refreshValueData(){
      DictionaryService.getValueList(this.selectedRow.key).then(data=>{
        this.values = data;
      }).catch(e=>{
        console.log("e",e);
      });
    },
    //添加值
    addValue(){
      if (this.selectedRow == null){
        this.$message.warn("请先选中要操作的字典类型");
        return;
      }
      this.modalAddValue.show = true;
    },
    //确认添加值
    confirmAddValue(e){
      e.preventDefault();
      this.modalAddValue.form.validateFields((err,values)=>{
        if (!err){
          values.sort = this.modalAddValue.model.sort;
          values.enable = this.modalAddValue.model.enable;
          values.remarks = this.modalAddValue.model.remarks;
          values.dictTypeKey = this.selectedRow.key;
          let _this = this;
          this.$confirm({
            title: "确定创建该字典值吗？",
            content: "单击确定创建",
            onOk: function (){
              DictionaryService.createValue(values).then(data=>{
                _this.modalAddValue.show = false;
                _this.modalAddValue.form.resetFields();
                _this.refreshValueData();
              }).catch(e=>{
                console.log("e",e);
                _this.$message.error(e);
              })
            }
          });
        }
      });
    },
    //取消添加值模态框
    cancelAddValue(){
      this.modalAddValue.show = false;
      this.modalAddValue.form.resetFields();
    },
    //修改值
    updateValue(item){
      this.modalUpdateValue.show = true;
      this.modalUpdateValue.item = item;
      this.modalUpdateValue.model.sort = item.sort;
      this.modalUpdateValue.model.enable = item.enable;
      this.modalUpdateValue.model.remarks = item.remarks;
      this.$nextTick(()=>{
        this.modalUpdateValue.form.setFieldsValue({
          value: item.value
        })
      })
    },
    //修改值点击确认
    confirmUpdateValue(e){
      e.preventDefault();
      let _this = this;
      this.modalUpdateValue.form.validateFields((err,values)=>{
        if (!err){
          values.sort = this.modalUpdateValue.model.sort;
          values.enable = this.modalUpdateValue.model.enable;
          values.remarks = this.modalUpdateValue.model.remarks;
          console.log("dada",values);
          _this.modalUpdateValue.confirmLoading = true;
          DictionaryService.updateValue(this.modalUpdateValue.item.id,values).then(data=>{
            _this.modalUpdateValue.confirmLoading = false;
            _this.modalUpdateValue.show = false;
            _this.refreshValueData();
          }).catch(e=>{
            console.log("e",e);
            this.$message.error(e);
          });
        }
      });
    },
    //取消修改值
    cancelUpdateValue(){
      this.modalUpdateValue.show = false;
      this.modalUpdateValue.form.resetFields();
    },
    //类型启用改变
    switchTypeEnable(item){
      let _this = this;
      this.$confirm({
        title: "确定" + (item.enable?"启用":"停用") + "该数据吗？",
        content: "点击确定提交结果",
        onOk(){
          DictionaryService.switchTypeEnable(item.key,item.enable).then(data=>{
            console.log("切换成功",data);
          }).catch(e=>{
            console.log("e",e);
            item.enable = !item.enable;
            _this.$message.error("切换失败");
          });
        },
        onCancel(){
          item.enable = !item.enable;
        }
      })
    },
    //切换值启用状态
    switchValueEnable(item) {
      let _this = this;
      this.$confirm({
        title: "确定" + (item.enable?"启用":"停用") + "该数据吗？",
        content: "点击确定提交结果",
        onOk(){
          DictionaryService.switchValueEnable(item.id,item.enable).then(data=>{
            console.log("切换成功",data);
          }).catch(e=>{
            console.log("e",e);
            item.enable = !item.enable;
            _this.$message.error("切换失败");
          });
        },
        onCancel(){
          item.enable = !item.enable;
        }
      })
    },
    //更新字典类型
    updateType(item){
      console.log("e",item);
      this.modalUpdateType.show = true;
      this.modalUpdateType.item = item;
      this.modalUpdateType.model.sort = item.sort;
      this.modalUpdateType.model.enable = item.enable;
      this.modalUpdateType.model.remarks = item.remarks;
      this.$nextTick(()=>{
        this.modalUpdateType.form.setFieldsValue({
          typeName: item.typeName
        })
      })
    },
    //确认更新类型
    confirmUpdateType(e){
      e.preventDefault();
      let _this = this;
      this.modalUpdateType.form.validateFields((err,values)=>{
        if (!err){
          values.remarks = this.modalUpdateType.model.remarks;
          values.sort = this.modalUpdateType.model.sort;
          values.enable = this.modalUpdateType.model.enable;
          _this.$confirm({
            title: '确认修改数据吗？',
            content: '点击确认提交',
            onOk(){
              DictionaryService.updateType(_this.modalUpdateType.item.id,values).then(data=>{
                console.log("修改成功",data);
                _this.modalUpdateType.show = false;
                _this.refreshTypeData();
                _this.selectedRow = _this.modalUpdateType.item;
              }).catch(e=>{
                console.log("e",e);
                _this.$message.error(e);
              })
            },
            onCancel(){
              _this.modalUpdateType.show = false;
            }
          });
        }
      });
    },
    //取消更新类型
    cancelUpdateType(){
      this.modalUpdateType.show = false;
      this.modalUpdateType.form.resetFields();
    },
    //删除类型
    deleteType(item){
      let _this = this;
      this.$confirm({
        title: '确定删除该字典类型吗？',
        content: '点击确认删除',
        onOk(){
          DictionaryService.deleteType(item.key).then(data=>{
            console.log("删除成功");
            _this.values = null;
            _this.selectedRow = null;
            _this.refreshTypeData();
          }).catch(e=>{
            console.log("e",e);
            _this.$message.error(e);
          })
        }
      })
    },
    //删除值
    deleteValue(item){
      let _this = this;
      this.$confirm({
        title: '确定删除该字典值吗？',
        content: '点击确认删除',
        onOk(){
          DictionaryService.deleteValue(item.id).then(data=>{
            console.log("删除成功");
            _this.refreshValueData();
          }).catch(e=>{
            console.log("e",e);
            _this.$message.error(e);
          })
        }
      })
    }
  },
  mounted() {
    this.table.scrollHeight = (document.documentElement.clientHeight || document.body.clientHeight) - 280;
    //获取数据
    this.refreshTypeData();
  }
}
</script>

<style lang="less">

.op-btn{
  margin-right: 8px;
}

#typeTable .selected-row{
  background-color: #999999;
}
</style>
